(function () {
  'use strict';

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- Predictive search (title, author, ISBN) ---------- */
  function initSearch(root) {
    var input = root.querySelector('input[name="q"]');
    var panel = root.querySelector('.bk-suggest');
    if (!input || !panel) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer, ctrl;

    function close() { panel.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); }

    function render(q, products) {
      var searchUrl = base + 'search?type=product&q=' + encodeURIComponent(q);
      if (!products.length) {
        panel.innerHTML = '<div class="bk-suggest__empty">' + esc(root.dataset.empty || 'No books found') + '</div>' +
          '<a class="bk-suggest__all" href="' + searchUrl + '">' + esc(root.dataset.all || 'Search all') + ' →</a>';
      } else {
        panel.innerHTML = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var thumb = img
            ? '<img class="bk-suggest__thumb" src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" loading="lazy">'
            : '<span class="bk-suggest__thumb" aria-hidden="true"></span>';
          var title = String(p.title || '').split(' — ')[0];
          return '<a class="bk-suggest__item" role="option" href="' + esc(p.url) + '">' + thumb +
            '<span><span class="bk-suggest__title">' + esc(title) + '</span><br>' +
            '<span class="bk-suggest__meta">' + esc(p.vendor || '') + (p.price ? ' · ' + esc(root.dataset.currency || '$') + esc(p.price) : '') + '</span></span></a>';
        }).join('') + '<a class="bk-suggest__all" href="' + searchUrl + '">' + esc(root.dataset.all || 'Search all') + ' →</a>';
      }
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = base + 'search/suggest.json?q=' + encodeURIComponent(q.replace(/-/g, '')) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][fields]=title,vendor,product_type,tag,variants.barcode,variants.sku,variants.title';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) { render(q, (d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  }

  /* ---------- Drawers (mobile menu, mobile filters, cart) ---------- */
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-bk-open]');
      if (opener) {
        var t = document.getElementById(opener.getAttribute('data-bk-open'));
        if (t) { t.classList.add('is-open'); opener.setAttribute('aria-expanded', 'true'); var f = t.querySelector('a,button,input'); if (f) f.focus(); }
        return;
      }
      var closer = e.target.closest('[data-bk-close]');
      if (closer) {
        var c = document.getElementById(closer.getAttribute('data-bk-close'));
        if (c) c.classList.remove('is-open');
        document.querySelectorAll('[data-bk-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.bk-drawer.is-open, .bk-filters.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    });
  }

  /* ---------- Collection filters + sort ---------- */
  function initFilters() {
    document.querySelectorAll('form[data-bk-filters]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"]')) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    });
    document.querySelectorAll('select[data-bk-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }

  /* ---------- Product: variant (condition / format) picker ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('script[data-bk-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form.bk-product-form');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-bk-add]');
    var dyn = form.querySelector('[data-bk-dyn]');
    var priceNow = root.querySelector('[data-bk-price]');
    var priceWas = root.querySelector('[data-bk-compare]');
    var stock = root.querySelector('[data-bk-stock]');
    var mainImg = root.querySelector('[data-bk-main-img]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-bk-option]'));

    function selected() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(vals) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); });
    }
    function markAvailability(vals) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (inp) {
          var test = vals.slice(); test[gi] = inp.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
          inp.closest('.bk-copy').classList.toggle('bk-copy--na', !ok);
          var priceEl = inp.closest('.bk-copy').querySelector('[data-bk-opt-price]');
          if (priceEl) {
            var match = variants.filter(function (v) { return v.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
            priceEl.textContent = match.length ? match[0].price : '';
          }
        });
      });
    }
    var hint = root.querySelector('[data-bk-cond-hint]');
    function update(e) {
      var vals = selected();
      if (hint) { var cn = root.querySelector('input[data-note]:checked'); hint.textContent = cn ? cn.getAttribute('data-note') : ''; }
      var v = find(vals);
      markAvailability(vals);
      if (!v) {
        btn.disabled = true; btn.textContent = btn.dataset.unavailable;
        if (dyn) dyn.hidden = true;
        if (stock) stock.textContent = '';
        return;
      }
      idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      document.querySelectorAll('[data-bk-sticky-price]').forEach(function (el) { el.textContent = v.price; });
      document.querySelectorAll('[data-bk-sticky-buy] button').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (priceWas) { priceWas.textContent = v.compare || ''; priceWas.hidden = !v.compare; }
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (dyn) dyn.hidden = !v.available;
      if (stock) stock.textContent = v.available ? (v.qty === 1 ? stock.dataset.one : '') : stock.dataset.none;
      if (e && v.image && mainImg) {
        mainImg.src = v.image; mainImg.removeAttribute('srcset');
        root.querySelectorAll('[data-bk-thumb]').forEach(function (o) { o.setAttribute('aria-current', o.getAttribute('data-bk-thumb') === v.image ? 'true' : 'false'); });
      }
      if (e) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });
    if (groups.length) update();

    root.querySelectorAll('[data-bk-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-bk-thumb'); mainImg.removeAttribute('srcset'); }
        root.querySelectorAll('[data-bk-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- Cart: drawer, add-to-cart, quantity changes ---------- */
  var CART_SECTION = 'bk-cart-drawer';
  function cartDrawer() { return document.getElementById('BkCartDrawer'); }
  function applyCartSections(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
    var fresh = doc.querySelector('[data-bk-cart-body]');
    var target = document.querySelector('#BkCartDrawer [data-bk-cart-body]');
    if (fresh && target) target.innerHTML = fresh.innerHTML;
    var count = doc.querySelector('[data-bk-cart-count-src]');
    if (count) {
      document.querySelectorAll('[data-bk-cart-count]').forEach(function (el) { el.textContent = count.textContent.trim(); });
      document.querySelectorAll('.bk-cart-btn').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + count.textContent.trim() + ' items'); });
    }
  }
  function openCart() {
    var d = cartDrawer(); if (!d) return false;
    d.classList.add('is-open');
    var c = d.querySelector('button[data-bk-close]'); if (c) c.focus();
    return true;
  }
  function showCartError(scope, msg) {
    var el = scope && scope.querySelector('[data-bk-cart-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
  }
  function initCart() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('bk-product-form') || !cartDrawer()) return;
      e.preventDefault();
      var btn = form.querySelector('[data-bk-add]');
      var err = form.querySelector('.bk-pdp__error') || (function () { var p = document.createElement('p'); p.className = 'bk-pdp__error'; p.setAttribute('role', 'alert'); form.appendChild(p); return p; })();
      err.textContent = '';
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      var fd = new FormData(form);
      fd.append('sections', CART_SECTION);
      fd.append('sections_url', window.location.pathname);
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { err.textContent = res.d.description || res.d.message || 'Could not add this book.'; return; }
          applyCartSections(res.d.sections);
          openCart();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bk-change]');
      if (!a) return;
      e.preventDefault();
      var wrap = a.closest('.bk-cart');
      var onPage = !!a.closest('[data-bk-page-cart]');
      if (wrap) wrap.classList.add('is-busy');
      fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(a.dataset.line), quantity: Number(a.dataset.qty), sections: CART_SECTION, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (wrap) wrap.classList.remove('is-busy');
            showCartError(wrap, res.d.description || res.d.message || 'Only the copies in stock can be added.');
            return;
          }
          if (onPage) { window.location.reload(); return; }
          applyCartSections(res.d.sections);
        })
        .catch(function () { window.location.href = a.href; });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.bk-cart-btn');
      if (link && !document.querySelector('[data-bk-page-cart]') && openCart()) e.preventDefault();
    });
  }

  /* ---------- Sticky add-to-cart on phones ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-bk-sticky-buy]');
    var main = document.querySelector('.bk-pdp__buy');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
      bar.classList.toggle('is-visible', !visible);
    }).observe(main);
    bar.querySelector('button').addEventListener('click', function () {
      var form = document.querySelector('form.bk-product-form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  function initReco(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.dataset.loaded) return;
    el.dataset.loaded = '1';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-bk-reco]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-bk-search]').forEach(initSearch);
    document.querySelectorAll('[data-bk-product]').forEach(initProduct);
    document.querySelectorAll('[data-bk-reco]').forEach(initReco);
    initDrawers();
    initFilters();
    initCart();
    initStickyBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bk-search]').forEach(initSearch);
    e.target.querySelectorAll('[data-bk-product]').forEach(initProduct);
  });
})();
